export function getVehicleAge(vehicleYear) {
  const year = Number(vehicleYear);
  const currentYear = new Date().getFullYear();
  return Number.isFinite(year) && year > 0 && currentYear > year ? currentYear - year : 0;
}
